import {NgModule} from '@angular/core';

import {HgConfigPage} from './page/overview/hc-config/hg-config.page';
import {HgDashboardPage} from './page/overview/hg-dashboard/hg-dashboard.page';
import {HgUploadPage} from './page/overview/hg-upload/hg-upload.page';
import {
    HgGdvPartnerBaseComponent
} from './component/object-components/hg-gdv-partner-object-component/view/hg-gdv-partner-base.component';
import {
    HgGdvPartnerObjectComponent
} from './component/object-components/hg-gdv-partner-object-component/hg-gdv-partner-object.component';
import {
    HgGdvPartnerSideComponent
} from './component/object-components/hg-gdv-partner-object-component/view/side/hg-gdv-partner-side.component';
import {
    HgGdvPartnerFullComponent
} from './component/object-components/hg-gdv-partner-object-component/view/full/hg-gdv-partner-full.component';
import {LgModule} from '../../feature-power/lg/lg.module';
import {EmModule} from '../em/em.module';
import {
    HgTestComponent
} from './component/object-components/hg-gdv-partner-object-component/view/shared/hg-test-component/hg-test.component';
import {
    HgUploadWizardComponent
} from './component/protected-components/hg-upload-wizard/hg-upload-wizard.component';
import {HG_ENTITY_PROVIDER} from './hg.entity-provider';
import {CoreModule} from '../../core/core.module';
import {HG_TEST_PROVIDERS} from './test/hg-test-definition';
import {
    HgImportObjectComponent
} from './component/object-components/hg-import-object-component/hg-import-object.component';
import {
    HgImportObjectFullComponent
} from './component/object-components/hg-import-object-component/view/hg-import-object-full-component/hg-import-object-full.component';
import {
    HgImportObjectSideComponent
} from './component/object-components/hg-import-object-component/view/hg-import-object-side-component/hg-import-object-side.component';
import {
    HgImportBasicDetailsComponent
} from './component/object-components/hg-import-object-component/shared/hg-import-basic-details/hg-import-basic-details.component';
import {
    HgImportEiProgressComponent
} from './component/object-components/hg-import-object-component/shared/hg-import-ei-progress/hg-import-ei-progress.component';
import {
    HgImportErrorDisplayComponent
} from './component/object-components/hg-import-object-component/shared/hg-import-error-display/hg-import-error-display.component';
import {
    HgPartnerSchemaSetupDialogComponent
} from './component/protected-components/hg-partner-schema-setup-dialog/hg-partner-schema-setup-dialog.component';

@NgModule({
  declarations: [
    HgConfigPage,
    HgDashboardPage,
    HgUploadPage,
    HgGdvPartnerBaseComponent,
    HgGdvPartnerObjectComponent,
    HgGdvPartnerSideComponent,
    HgGdvPartnerFullComponent,
    HgTestComponent,
    HgUploadWizardComponent,
    HgImportObjectComponent,
    HgImportObjectFullComponent,
    HgImportObjectSideComponent,
    HgImportBasicDetailsComponent,
    HgImportEiProgressComponent,
    HgImportErrorDisplayComponent,
    HgPartnerSchemaSetupDialogComponent,

  ],
  exports:[
    HgConfigPage,
    HgDashboardPage,
    HgUploadPage,
    HgGdvPartnerBaseComponent,
    HgGdvPartnerObjectComponent,
    HgGdvPartnerSideComponent,
    HgGdvPartnerFullComponent,
    HgTestComponent,
    HgUploadWizardComponent,
    HgImportObjectComponent,
    HgImportObjectFullComponent,
    HgImportObjectSideComponent,
    HgImportBasicDetailsComponent,
    HgImportEiProgressComponent,
    HgImportErrorDisplayComponent,
    HgPartnerSchemaSetupDialogComponent,
  ],
  imports: [
    CoreModule,
    LgModule,
    EmModule,

  ],
  providers: [HG_ENTITY_PROVIDER, HG_TEST_PROVIDERS]
})
export class HgModule { }
